module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "Helen-min.63225d0b.jpg";